import { FetchAttributesActionTypes, UpdatePhoneNumberActionTypes, UpdateLanguageWithLocaleActionTypes, UpdateLocaleWithLanguageActionTypes, UpdateUnsubscribeLinkActionTypes, UpdateDefaultPhoneCountryCodeActionTypes, UpdateDefaultHomeActionTypes } from '../actions/AttributeActions';
import { handleActions } from 'flux-actions';
import UserAttributes from '../records/UserAttributes';
const initialState = new UserAttributes();
export default handleActions({
  [FetchAttributesActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge(action.payload.data);
  },
  [UpdateLanguageWithLocaleActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.mergeIn(['languageAndLocale'], action.payload.props);
  },
  [UpdateLocaleWithLanguageActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.mergeIn(['languageAndLocale'], action.payload.props);
  },
  [UpdateDefaultPhoneCountryCodeActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('defaultPhoneCountryCode', action.payload.props);
  },
  [UpdatePhoneNumberActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('phoneNumber', action.payload.props);
  },
  [UpdateUnsubscribeLinkActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('unsubscribeLinkType', action.payload.props);
  },
  [UpdateDefaultHomeActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('defaultHome', action.payload.props);
  }
}, initialState);